export default __webpack_public_path__ + "static/media/verified.822e923b.svg";